import Title from 'components/common/Title'
import { useTenantProfile } from 'hooks/api/tenant/useTenantProfile'
import Text from 'components/common/Text'
import { Container, Row, Col } from 'react-bootstrap'
import Link from 'components/common/Link'
import HeroHome from 'assets/inline/HeroHome.jpg'
import { useRouter } from 'next/router'
import Button from 'components/common/Button'

export const HeroBlock = () => {
	const { data: tenantProfile } = useTenantProfile()
	const primaryColor = tenantProfile?.theme?.primaryColor

	return (
		<div>
			<Container>
				<Row>
					<Col md={4} lg={{ span: 5, offset: 1 }} className={'d-none d-md-block'}>
						<div
							style={{
								flex: 1,
								display: 'flex',
								justifyContent: 'center',
								flexDirection: 'column',
								height: '100%',
							}}
						>
							<img src={HeroHome} style={{ borderRadius: 10, width: '100%' }} />
						</div>
					</Col>
					<Col xs={12} sm={12} md={8} lg={6}>
						<div
							style={{
								flex: 1,
								display: 'flex',
								justifyContent: 'center',
								flexDirection: 'column',
								height: '100%',
							}}
						>
							<Title large style={{ fontWeight: 'bold', marginBottom: 20 }}>
								Help Your Clients Avoid Overpaying Property Taxes
							</Title>
							<Text style={{ marginBottom: 20 }}>
								And build stronger, more loyal relationships.
							</Text>

							<Link to='/partners/signup'>
								<Button
									background={primaryColor}
									style={{
										maxWidth: 200,
										padding: 15,
										height: 'auto',
										fontSize: 16,
										fontWeight: 'bold',
									}}
								>
									Create a Profile
								</Button>
							</Link>
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	)
}
